import React from "react"
import { Header } from "./controls/header"
import { Main } from "./controls/main"
import { Footer } from "./controls/footer"
import { CookieConsent } from "./controls/CookieConsent"

export const LayoutStandardPage = ({component}:{component:any}) => {
    return(
        <React.Fragment>
            <Header />
            <Main component={component} />
            <Footer />
            <CookieConsent />
        </React.Fragment>
    )
}